import { render } from "./AssessPIV.vue?vue&type=template&id=4e904435&scoped=true"
import script from "./AssessPIV.vue?vue&type=script&lang=js"
export * from "./AssessPIV.vue?vue&type=script&lang=js"

import "./AssessPIV.vue?vue&type=style&index=0&id=4e904435&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e904435"]])

export default __exports__